// certificatePresets.js — certificate types, border presets, body HTML, 12 template designs

// ── Certificate types ────────────────────────────────────────────────────

export const CERT_TYPES = [
  { value: 'tc',          label: 'Transfer Certificate (TC)'  },
  { value: 'bonafide',    label: 'Bonafide Certificate'        },
  { value: 'study',       label: 'Study Certificate'           },
  { value: 'recordsheet', label: 'Record Sheet'                },
  { value: 'idcard',      label: 'Student ID Card'             },
];

// ── Border presets ───────────────────────────────────────────────────────

export const BORDER_PRESETS = [
  {
    id: 'classic',
    name: 'Classic School',
    style: 'solid', thickness: 3, color: '#1a237e', radius: 0,
    inner: true, innerColor: '#1a237e', innerThickness: 1.5, innerInset: 8,
  },
  {
    id: 'double',
    name: 'Double Border',
    style: 'double', thickness: 8, color: '#1a237e', radius: 0,
    inner: false,
  },
  {
    id: 'decorative',
    name: 'Decorative Brown',
    style: 'solid', thickness: 10, color: '#8B4513', radius: 4,
    inner: true, innerColor: '#DAA520', innerThickness: 2, innerInset: 14,
  },
  {
    id: 'modern',
    name: 'Purple Modern',
    style: 'solid', thickness: 4, color: '#7c3aed', radius: 16,
    inner: false,
  },
  {
    id: 'golden',
    name: 'Golden Certificate',
    style: 'solid', thickness: 8, color: '#B8860B', radius: 2,
    inner: true, innerColor: '#DAA520', innerThickness: 2, innerInset: 12,
  },
  {
    id: 'maroon',
    name: 'Royal Maroon',
    style: 'solid', thickness: 6, color: '#800000', radius: 0,
    inner: true, innerColor: '#c0392b', innerThickness: 1.5, innerInset: 10,
  },
  {
    id: 'green',
    name: 'Green Minimal',
    style: 'solid', thickness: 3, color: '#16a34a', radius: 12,
    inner: false,
  },
  {
    id: 'teal',
    name: 'Teal Elegant',
    style: 'solid', thickness: 5, color: '#0891b2', radius: 0,
    inner: true, innerColor: '#67e8f9', innerThickness: 1, innerInset: 10,
  },
  {
    id: 'none',
    name: 'No Border',
    style: 'none', thickness: 0, color: 'transparent', radius: 0,
    inner: false,
  },
];

// ── Body HTML templates (use {{variable}} tokens) ─────────────────────────

// 1. Transfer Certificate — classic table with borders
const TC_BODY = `<div style="padding:8px 0;font-family:'Times New Roman',serif;">
  <div style="display:flex;justify-content:space-between;margin-bottom:14px;font-size:12px;">
    <span>Admn. No:&nbsp;<u><b>{{admission_no}}</b></u></span>
    <span>TC No:&nbsp;<u><b>{{tc_no}}</b></u></span>
    <span>Date:&nbsp;<u><b>{{date}}</b></u></span>
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:13px;border-top:1px solid #999;">
    <tr><td style="padding:6px 8px;width:55%;border:1px solid #ccc;">1.&nbsp;Name of the Pupil (in full)</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{student_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;border:1px solid #ccc;">2.&nbsp;Name of the Father (in full)</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{father_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;border:1px solid #ccc;">3.&nbsp;Name of the Mother (in full)</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{mother_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;border:1px solid #ccc;">4.&nbsp;Date of Birth</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{dob}}</b></td></tr>
    <tr><td style="padding:6px 8px;border:1px solid #ccc;">5.&nbsp;Religion &amp; Nationality</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{religion}} / {{nationality}}</b></td></tr>
    <tr><td style="padding:6px 8px;border:1px solid #ccc;">6.&nbsp;Class at time of leaving</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{class_name}} &#8212; {{section_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;border:1px solid #ccc;">7.&nbsp;Academic Year</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{academic_year}}</b></td></tr>
    <tr><td style="padding:6px 8px;border:1px solid #ccc;">8.&nbsp;Conduct</td><td style="padding:6px 8px;border:1px solid #ccc;"><b>{{conduct}}</b></td></tr>
  </table>
</div>`;

// 1b. Transfer Certificate — text only (no table borders, colon separator)
export const TC_BODY_TEXT = `<div style="padding:8px 0;font-family:'Times New Roman',serif;">
  <div style="display:flex;justify-content:space-between;margin-bottom:14px;font-size:12px;">
    <span>Admn. No:&nbsp;<u><b>{{admission_no}}</b></u></span>
    <span>TC No:&nbsp;<u><b>{{tc_no}}</b></u></span>
    <span>Date:&nbsp;<u><b>{{date}}</b></u></span>
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:13px;">
    <tr><td style="padding:6px 8px;width:55%;">1.&nbsp;Name of the Pupil (in full)</td><td style="padding:6px 8px;width:4px;">:</td><td style="padding:6px 8px;"><b>{{student_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;">2.&nbsp;Name of the Father (in full)</td><td style="padding:6px 8px;">:</td><td style="padding:6px 8px;"><b>{{father_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;">3.&nbsp;Name of the Mother (in full)</td><td style="padding:6px 8px;">:</td><td style="padding:6px 8px;"><b>{{mother_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;">4.&nbsp;Date of Birth</td><td style="padding:6px 8px;">:</td><td style="padding:6px 8px;"><b>{{dob}}</b></td></tr>
    <tr><td style="padding:6px 8px;">5.&nbsp;Religion &amp; Nationality</td><td style="padding:6px 8px;">:</td><td style="padding:6px 8px;"><b>{{religion}} / {{nationality}}</b></td></tr>
    <tr><td style="padding:6px 8px;">6.&nbsp;Class at time of leaving</td><td style="padding:6px 8px;">:</td><td style="padding:6px 8px;"><b>{{class_name}} &#8212; {{section_name}}</b></td></tr>
    <tr><td style="padding:6px 8px;">7.&nbsp;Academic Year</td><td style="padding:6px 8px;">:</td><td style="padding:6px 8px;"><b>{{academic_year}}</b></td></tr>
    <tr><td style="padding:6px 8px;">8.&nbsp;Conduct</td><td style="padding:6px 8px;">:</td><td style="padding:6px 8px;"><b>{{conduct}}</b></td></tr>
  </table>
</div>`;

// 2. Bonafide — flowing paragraph (no line breaks between lines, single underline)
const BONAFIDE_BODY = `<div style="font-family:'Times New Roman',serif;">
  <div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0 12px;border-top:1px solid #c5cae9;font-size:13.5px;">
    <span>Admn. No.&nbsp;&nbsp;<span style="display:inline-block;min-width:110px;border-bottom:1.5px solid #000;font-weight:600;font-style:normal;padding-bottom:2px;">{{admission_no}}</span></span>
    <span>Date :&nbsp;<span style="display:inline-block;min-width:130px;border-bottom:1px dotted #555;padding-bottom:2px;">{{date}}</span></span>
  </div>
  <div style="padding:8px 0;">
    <p style="font-style:italic;font-size:14px;line-height:3.2;margin:0 0 18px 0;">This is to Certify that Master / Miss&nbsp;<span style="border-bottom:1.5px solid #000;font-weight:600;font-style:normal;padding-bottom:2px;">{{student_name}}</span>,&nbsp;Son/Daughter of&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:180px;border-bottom:1.5px solid #000;padding-bottom:1px;font-weight:600;font-style:normal;">{{father_name}}</span>&nbsp;is a Bonafide Student of this Institution studying in Class&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:120px;border-bottom:1.5px solid #000;padding-bottom:1px;font-weight:600;font-style:normal;">{{class_name}}</span>&nbsp;during the year&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:90px;border-bottom:1.5px solid #000;padding-bottom:1px;font-weight:600;font-style:normal;">{{academic_year}}</span>.</p>
    <p style="font-style:italic;font-size:14px;line-height:3.2;margin:0 0 18px 0;">His / Her Date of Birth as per record is&nbsp;<span style="border-bottom:1.5px solid #000;font-weight:600;font-style:normal;padding-bottom:2px;">{{dob}}</span>.</p>
    <div style="text-align:center;font-weight:bold;font-size:15px;margin-top:8px;">His / Her Character &amp; Conduct found to be good.</div>
  </div>
</div>`;

// 3. Study Certificate — matches physical certificate image text exactly
const STUDY_BODY = `<div style="font-family:'Times New Roman',serif;">
  <div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0 12px;border-top:1px solid #c5cae9;font-size:13.5px;">
    <span>Admn. No.&nbsp;&nbsp;<span style="display:inline-block;min-width:110px;border-bottom:1.5px solid #000;font-weight:600;font-style:normal;padding-bottom:2px;">{{admission_no}}</span></span>
    <span>Date :&nbsp;<span style="display:inline-block;min-width:130px;border-bottom:1px dotted #555;padding-bottom:2px;">{{date}}</span></span>
  </div>
  <div style="padding:8px 0;">
    <p style="font-style:italic;font-size:14px;line-height:3.2;margin:0 0 18px 0;">This is to Certify that Master / Miss&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:200px;border-bottom:1.5px solid #000;font-weight:600;font-style:normal;padding-bottom:2px;">{{student_name}}</span></p>
    <p style="font-style:italic;font-size:14px;line-height:3.2;margin:0 0 18px 0;">Son/Daughter of&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:200px;border-bottom:1.5px solid #000;padding-bottom:1px;font-weight:600;font-style:normal;">{{father_name}}</span>&nbsp;/ was a Bonafide Student of this</p>
    <p style="font-style:italic;font-size:14px;line-height:3.2;margin:0 0 18px 0;">Institution studying / studied in Class&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:180px;border-bottom:1.5px solid #000;padding-bottom:1px;font-weight:600;font-style:normal;">{{class_name}}</span>&nbsp;during the year&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:90px;border-bottom:1.5px solid #000;padding-bottom:1px;font-weight:600;font-style:normal;">{{academic_year}}</span></p>
    <p style="font-style:italic;font-size:14px;line-height:3.2;margin:0 0 18px 0;">His / Her Date of Birth as per record is&nbsp;<span style="display:inline-block;vertical-align:bottom;min-width:240px;border-bottom:1.5px solid #000;font-weight:600;font-style:normal;padding-bottom:2px;">{{dob}}</span></p>
    <div style="text-align:center;font-weight:bold;font-size:15px;margin-top:8px;">His / Her Character &amp; Conduct found to be good.</div>
  </div>
</div>`;

// 4. Record Sheet — extended table (16 rows)
const RECORD_BODY = `<div style="padding:6px 0;font-family:'Times New Roman',serif;">
  <div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:10px;">
    <span>Date: <u><b>{{date}}</b></u></span>
    <span>UDISE No.: <u><b>{{school_code}}</b></u></span>
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:13px;border-top:1px solid #888;">
    <tr><td style="padding:5px 8px;width:5%;border:1px solid #ccc;">1.</td><td style="padding:5px 8px;width:52%;border:1px solid #ccc;">Admission Number</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{admission_no}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">2.</td><td style="padding:5px 8px;border:1px solid #ccc;">Name of the Pupil (in full)</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{student_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">3.</td><td style="padding:5px 8px;border:1px solid #ccc;">Date of Birth</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{dob}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">4.</td><td style="padding:5px 8px;border:1px solid #ccc;">Name of the Father (in full)</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{father_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">5.</td><td style="padding:5px 8px;border:1px solid #ccc;">Name of the Mother (in full)</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{mother_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">6.</td><td style="padding:5px 8px;border:1px solid #ccc;">Nationality and Religion</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{nationality}} / {{religion}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">7.</td><td style="padding:5px 8px;border:1px solid #ccc;">Promotion Status for the Academic Year</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{promotion_status}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">8.</td><td style="padding:5px 8px;border:1px solid #ccc;">Conduct</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{conduct}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">9.</td><td style="padding:5px 8px;border:1px solid #ccc;">PEN No</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{pen_no}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">10.</td><td style="padding:5px 8px;border:1px solid #ccc;">Aadhar No</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{aadhar_no}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">11.</td><td style="padding:5px 8px;border:1px solid #ccc;">Class / Date of Admission</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{class_name}} / {{admission_date}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">12.</td><td style="padding:5px 8px;border:1px solid #ccc;">First Language</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{first_lang}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">13.</td><td style="padding:5px 8px;border:1px solid #ccc;">Second Language</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{second_lang}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">14.</td><td style="padding:5px 8px;border:1px solid #ccc;">Mother Tongue</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{mother_tongue}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">15.</td><td style="padding:5px 8px;border:1px solid #ccc;">Date of Leaving</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{leaving_date}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #ccc;">16.</td><td style="padding:5px 8px;border:1px solid #ccc;">No. Of Working Days / Days Present</td><td style="padding:5px 8px;border:1px solid #ccc;"><b>{{working_days}}</b></td></tr>
  </table>
</div>`;

// 5. Elegant Blue — centered with decorators
const ELEGANT_BODY = `<div style="padding:16px 0;font-family:Georgia,serif;font-size:14px;line-height:2.8;text-align:center;">
  <div style="font-size:22px;letter-spacing:6px;color:#1565c0;margin-bottom:6px;">&#10022; &#10022; &#10022;</div>
  <p>This is to certify that <u style="color:#1565c0;"><b>{{student_name}}</b></u></p>
  <p>Son / Daughter of <u><b>{{father_name}}</b></u></p>
  <p>bearing Admission No. <u><b>{{admission_no}}</b></u> was a Bonafide Student of this Institution</p>
  <p>studying in Class <u><b>{{class_name}}</b></u> &#8212; Section <u><b>{{section_name}}</b></u> during <u><b>{{academic_year}}</b></u></p>
  <p>Date of Birth as per records: <u><b>{{dob}}</b></u></p>
  <br/>
  <div style="font-size:22px;letter-spacing:6px;color:#1565c0;">&#10022; &#10022; &#10022;</div>
  <p style="font-weight:bold;font-size:15px;color:#1565c0;margin-top:10px;">His / Her Character &amp; Conduct has been found Good throughout the period of study.</p>
</div>`;

// 6. Royal Maroon TC — formal table with maroon styling
const MAROON_TC_BODY = `<div style="padding:8px 0;font-family:'Times New Roman',serif;">
  <table style="width:100%;margin-bottom:12px;font-size:12px;">
    <tr>
      <td style="padding:4px 0;"><b>Serial No:</b> <u>{{serial_no}}</u></td>
      <td style="padding:4px 0;text-align:center;"><b>TC No:</b> <u>{{tc_no}}</u></td>
      <td style="padding:4px 0;text-align:right;"><b>Date:</b> <u>{{date}}</u></td>
    </tr>
  </table>
  <table style="width:100%;border-collapse:collapse;font-size:13px;">
    <thead>
      <tr><th colspan="2" style="background:#800000;color:#fff;padding:8px;text-align:center;font-size:13px;letter-spacing:1px;">STUDENT PARTICULARS</th></tr>
    </thead>
    <tbody>
      <tr style="background:#fff8f8;"><td style="padding:7px 10px;border:1px solid #c0392b;width:55%;">Name of the Pupil</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{student_name}}</b></td></tr>
      <tr><td style="padding:7px 10px;border:1px solid #c0392b;">Father's Name</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{father_name}}</b></td></tr>
      <tr style="background:#fff8f8;"><td style="padding:7px 10px;border:1px solid #c0392b;">Mother's Name</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{mother_name}}</b></td></tr>
      <tr><td style="padding:7px 10px;border:1px solid #c0392b;">Date of Birth</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{dob}}</b></td></tr>
      <tr style="background:#fff8f8;"><td style="padding:7px 10px;border:1px solid #c0392b;">Admission No</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{admission_no}}</b></td></tr>
      <tr><td style="padding:7px 10px;border:1px solid #c0392b;">Religion / Nationality</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{religion}} / {{nationality}}</b></td></tr>
      <tr style="background:#fff8f8;"><td style="padding:7px 10px;border:1px solid #c0392b;">Class at time of leaving</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{class_name}} &#8212; {{section_name}}</b></td></tr>
      <tr><td style="padding:7px 10px;border:1px solid #c0392b;">Academic Year</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{academic_year}}</b></td></tr>
      <tr style="background:#fff8f8;"><td style="padding:7px 10px;border:1px solid #c0392b;">Conduct</td><td style="padding:7px 10px;border:1px solid #c0392b;"><b>{{conduct}}</b></td></tr>
    </tbody>
  </table>
</div>`;

// 7. Green Minimal — clean left-aligned study cert
const GREEN_STUDY_BODY = `<div style="padding:16px 0;font-family:'Segoe UI',Arial,sans-serif;font-size:14px;line-height:2.4;text-align:left;">
  <div style="border-left:4px solid #16a34a;padding-left:16px;margin-bottom:16px;">
    <p style="margin:0;"><b>Admission No:</b> {{admission_no}} &nbsp;&nbsp; <b>Date:</b> {{date}}</p>
  </div>
  <p>This is to certify that <b style="color:#15803d;">{{student_name}}</b>, Son/Daughter of <b>{{father_name}}</b>, is / was a bonafide student of this institution.</p>
  <br/>
  <p>He/She studied in <b>Class {{class_name}}</b>, Section <b>{{section_name}}</b> during the Academic Year <b>{{academic_year}}</b>.</p>
  <br/>
  <p>&#9654; Date of Birth: <b>{{dob}}</b></p>
  <p>&#9654; Religion: <b>{{religion}}</b> &nbsp;&nbsp; Nationality: <b>{{nationality}}</b></p>
  <p>&#9654; His/Her conduct has been <b>{{conduct}}</b> throughout the period of study.</p>
  <br/>
  <p style="font-style:italic;color:#555;">This certificate is issued on request for official purposes.</p>
</div>`;

// 8. Government Official TC — formal numbered, black & white
const GOVT_TC_BODY = `<div style="padding:8px 0;font-family:'Times New Roman',serif;font-size:13px;">
  <div style="display:flex;justify-content:space-between;border:1px solid #000;padding:6px 10px;margin-bottom:10px;">
    <span><b>Sl. No:</b> {{serial_no}}</span>
    <span><b>Admn. No:</b> {{admission_no}}</span>
    <span><b>TC No:</b> {{tc_no}}</span>
    <span><b>Date:</b> {{date}}</span>
  </div>
  <p style="text-align:center;font-weight:bold;font-size:12px;text-decoration:underline;margin-bottom:8px;">STUDENT INFORMATION</p>
  <table style="width:100%;border-collapse:collapse;font-size:13px;">
    <tr><td style="padding:5px 8px;border:1px solid #000;width:5%;">1</td><td style="padding:5px 8px;border:1px solid #000;width:50%;">Full Name of Pupil</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{student_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">2</td><td style="padding:5px 8px;border:1px solid #000;">Father's Name</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{father_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">3</td><td style="padding:5px 8px;border:1px solid #000;">Mother's Name</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{mother_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">4</td><td style="padding:5px 8px;border:1px solid #000;">Date of Birth</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{dob}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">5</td><td style="padding:5px 8px;border:1px solid #000;">PEN Number</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{pen_no}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">6</td><td style="padding:5px 8px;border:1px solid #000;">Aadhar Number</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{aadhar_no}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">7</td><td style="padding:5px 8px;border:1px solid #000;">Religion &amp; Caste</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{religion}} / {{category}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">8</td><td style="padding:5px 8px;border:1px solid #000;">Medium of Instruction</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{medium}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">9</td><td style="padding:5px 8px;border:1px solid #000;">Class at time of leaving</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{class_name}} &#8212; {{section_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">10</td><td style="padding:5px 8px;border:1px solid #000;">Conduct</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{conduct}}</b></td></tr>
  </table>
</div>`;

// 9. Decorative Ornate Bonafide — brown borders, centered paragraphs
const ORNATE_BODY = `<div style="padding:20px 10px;font-family:Georgia,serif;font-size:14px;line-height:3;text-align:center;">
  <div style="border-top:3px double #8B4513;border-bottom:3px double #8B4513;padding:6px 0;margin-bottom:16px;color:#8B4513;font-size:18px;letter-spacing:4px;">&#10020; CERTIFICATE &#10020;</div>
  <p><i>This is to certify that</i></p>
  <p style="font-size:18px;font-weight:bold;color:#8B4513;text-decoration:underline;letter-spacing:2px;">{{student_name}}</p>
  <p><i>Son / Daughter of</i> <b>{{father_name}}</b></p>
  <p><i>was a Bonafide Student of this Institution during the Academic Year</i></p>
  <p style="font-size:16px;font-weight:bold;">{{academic_year}}</p>
  <p><i>studying in Class</i> <b>{{class_name}}</b> <i>&#8212; Section</i> <b>{{section_name}}</b></p>
  <p><i>Date of Birth:</i> <b>{{dob}}</b></p>
  <div style="border-top:3px double #8B4513;border-bottom:3px double #8B4513;padding:8px 0;margin-top:16px;color:#8B4513;font-weight:bold;font-size:15px;">
    His / Her Character &amp; Conduct has been Exemplary throughout the period.
  </div>
</div>`;

// 10. Academic Pro Record — extended with all details
const ACADEMIC_RECORD_BODY = `<div style="padding:6px 0;font-family:'Times New Roman',serif;font-size:12px;">
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:4px;margin-bottom:10px;font-size:11px;">
    <span>Date: <u><b>{{date}}</b></u></span>
    <span style="text-align:right;">TC No: <u><b>{{tc_no}}</b></u></span>
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:12px;">
    <thead>
      <tr style="background:#1a237e;color:#fff;">
        <th style="padding:6px 8px;text-align:left;width:4%;">S.No</th>
        <th style="padding:6px 8px;text-align:left;width:48%;">Particulars</th>
        <th style="padding:6px 8px;text-align:left;">Details</th>
      </tr>
    </thead>
    <tbody>
      <tr style="background:#f0f4ff;"><td style="padding:5px 8px;border:1px solid #c5cae9;">1.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Admission Number</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{admission_no}}</b></td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #c5cae9;">2.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Full Name of Pupil</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{student_name}}</b></td></tr>
      <tr style="background:#f0f4ff;"><td style="padding:5px 8px;border:1px solid #c5cae9;">3.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Father's Name</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{father_name}}</b></td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #c5cae9;">4.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Mother's Name</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{mother_name}}</b></td></tr>
      <tr style="background:#f0f4ff;"><td style="padding:5px 8px;border:1px solid #c5cae9;">5.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Date of Birth</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{dob}}</b></td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #c5cae9;">6.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">PEN No / Aadhar No</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{pen_no}} / {{aadhar_no}}</b></td></tr>
      <tr style="background:#f0f4ff;"><td style="padding:5px 8px;border:1px solid #c5cae9;">7.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Nationality / Religion</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{nationality}} / {{religion}}</b></td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #c5cae9;">8.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Category</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{category}}</b></td></tr>
      <tr style="background:#f0f4ff;"><td style="padding:5px 8px;border:1px solid #c5cae9;">9.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Medium of Instruction</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{medium}}</b></td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #c5cae9;">10.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Class &amp; Section</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{class_name}} &#8212; {{section_name}}</b></td></tr>
      <tr style="background:#f0f4ff;"><td style="padding:5px 8px;border:1px solid #c5cae9;">11.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Academic Year</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{academic_year}}</b></td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #c5cae9;">12.</td><td style="padding:5px 8px;border:1px solid #c5cae9;">Conduct</td><td style="padding:5px 8px;border:1px solid #c5cae9;"><b>{{conduct}}</b></td></tr>
    </tbody>
  </table>
</div>`;

// 11. Minimal Modern — no border, typography-focused study cert
const MINIMAL_BODY = `<div style="padding:20px 0;font-family:'Segoe UI',Arial,sans-serif;font-size:14px;line-height:2.2;">
  <div style="display:flex;gap:40px;margin-bottom:20px;font-size:12px;color:#888;">
    <span>Admission No: <b style="color:#333;">{{admission_no}}</b></span>
    <span>Date: <b style="color:#333;">{{date}}</b></span>
  </div>
  <p style="font-size:15px;border-bottom:2px solid #7c3aed;padding-bottom:12px;margin-bottom:16px;">
    This is to certify that <b style="font-size:17px;color:#7c3aed;">{{student_name}}</b>,
    Son/Daughter of <b>{{father_name}}</b>, bearing Admission No. <b>{{admission_no}}</b>
    was a bonafide student of this institution.
  </p>
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;font-size:13px;">
    <div style="padding:10px 14px;background:#f5f3ff;border-radius:8px;"><b style="color:#7c3aed;">Class:</b><br/>{{class_name}} &#8212; {{section_name}}</div>
    <div style="padding:10px 14px;background:#f5f3ff;border-radius:8px;"><b style="color:#7c3aed;">Academic Year:</b><br/>{{academic_year}}</div>
    <div style="padding:10px 14px;background:#f5f3ff;border-radius:8px;"><b style="color:#7c3aed;">Date of Birth:</b><br/>{{dob}}</div>
    <div style="padding:10px 14px;background:#f5f3ff;border-radius:8px;"><b style="color:#7c3aed;">Conduct:</b><br/>{{conduct}}</div>
  </div>
  <br/>
  <p style="font-size:13px;color:#555;font-style:italic;">Religion: <b style="color:#333;">{{religion}}</b> &nbsp;|&nbsp; Nationality: <b style="color:#333;">{{nationality}}</b></p>
  <p style="font-size:13px;color:#555;margin-top:10px;font-style:italic;">This certificate is issued on request for academic/official purposes.</p>
</div>`;

// 12. Teal Landscape-inspired — two-column detail grid
const TEAL_BODY = `<div style="padding:10px 0;font-family:'Times New Roman',serif;font-size:13px;">
  <div style="background:#e0f7fa;border-left:4px solid #0891b2;padding:8px 12px;margin-bottom:14px;display:flex;justify-content:space-between;">
    <span><b>Admn. No:</b> {{admission_no}}</span>
    <span><b>TC No:</b> {{tc_no}}</span>
    <span><b>Date:</b> {{date}}</span>
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:13px;">
    <tr>
      <td colspan="4" style="background:#0891b2;color:#fff;padding:7px 10px;font-weight:bold;font-size:13px;text-align:center;letter-spacing:1.5px;">STUDENT DETAILS</td>
    </tr>
    <tr>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;width:25%;font-weight:bold;">Student Name</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;width:25%;"><b>{{student_name}}</b></td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;width:25%;font-weight:bold;">Admission No</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;width:25%;"><b>{{admission_no}}</b></td>
    </tr>
    <tr>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Father's Name</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{father_name}}</b></td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Mother's Name</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{mother_name}}</b></td>
    </tr>
    <tr>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Date of Birth</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{dob}}</b></td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Class &amp; Section</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{class_name}} &#8212; {{section_name}}</b></td>
    </tr>
    <tr>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Religion</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{religion}}</b></td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Nationality</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{nationality}}</b></td>
    </tr>
    <tr>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Academic Year</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{academic_year}}</b></td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;background:#f0fdfe;font-weight:bold;">Conduct</td>
      <td style="padding:6px 8px;border:1px solid #b2ebf2;"><b>{{conduct}}</b></td>
    </tr>
  </table>
</div>`;

// 13. Saffron Tricolor TC — India-flag accent colors
const SAFFRON_TC_BODY = `<div style="padding:8px 0;font-family:'Times New Roman',serif;">
  <table style="width:100%;margin-bottom:12px;font-size:12px;">
    <tr>
      <td style="padding:4px 0;"><b>Sl. No:</b> <u>{{serial_no}}</u></td>
      <td style="text-align:center;"><b>Admn. No:</b> <u>{{admission_no}}</u></td>
      <td style="text-align:right;"><b>Date:</b> <u>{{date}}</u></td>
    </tr>
  </table>
  <table style="width:100%;border-collapse:collapse;font-size:13px;">
    <thead>
      <tr><th colspan="2" style="background:#FF9933;color:#fff;padding:8px;text-align:center;font-size:13px;letter-spacing:1px;">STUDENT PARTICULARS</th></tr>
    </thead>
    <tbody>
      <tr><td style="padding:7px 10px;border:1px solid #FF9933;width:55%;">Name of the Pupil (in full)</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{student_name}}</b></td></tr>
      <tr style="background:#fff8f0;"><td style="padding:7px 10px;border:1px solid #FF9933;">Father's Name</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{father_name}}</b></td></tr>
      <tr><td style="padding:7px 10px;border:1px solid #FF9933;">Mother's Name</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{mother_name}}</b></td></tr>
      <tr style="background:#fff8f0;"><td style="padding:7px 10px;border:1px solid #FF9933;">Date of Birth</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{dob}}</b></td></tr>
      <tr><td style="padding:7px 10px;border:1px solid #FF9933;">Religion / Nationality</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{religion}} / {{nationality}}</b></td></tr>
      <tr style="background:#fff8f0;"><td style="padding:7px 10px;border:1px solid #FF9933;">Class at time of leaving</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{class_name}} &#8212; {{section_name}}</b></td></tr>
      <tr><td style="padding:7px 10px;border:1px solid #FF9933;">Academic Year</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{academic_year}}</b></td></tr>
      <tr style="background:#fff8f0;"><td style="padding:7px 10px;border:1px solid #FF9933;">Conduct</td><td style="padding:7px 10px;border:1px solid #FF9933;"><b>{{conduct}}</b></td></tr>
    </tbody>
  </table>
  <div style="margin-top:10px;padding:8px 10px;background:#f1f8e9;border-left:4px solid #138808;font-size:12px;color:#1b5e20;font-style:italic;">
    This Transfer Certificate is issued on leaving the institution.
  </div>
</div>`;

// 14. TS Government Official TC — Telangana numbered format
const TS_GOVT_BODY = `<div style="padding:8px 0;font-family:'Times New Roman',serif;font-size:13px;">
  <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:4px;border:1px solid #000;padding:6px 10px;margin-bottom:6px;font-size:12px;">
    <span><b>Sl. No.:</b> {{serial_no}}</span>
    <span style="text-align:center;"><b>Admn. No.:</b> {{admission_no}}</span>
    <span style="text-align:right;"><b>Date:</b> {{date}}</span>
  </div>
  <p style="text-align:center;font-size:11px;font-style:italic;margin:0 0 8px;color:#555;">(To be retained permanently in the records of the Institution to which the pupil proceeds)</p>
  <table style="width:100%;border-collapse:collapse;font-size:13px;">
    <tr><td style="padding:5px 8px;border:1px solid #000;width:5%;">1</td><td style="padding:5px 8px;border:1px solid #000;width:52%;">Full Name of the Pupil (in CAPITAL LETTERS)</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{student_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">2</td><td style="padding:5px 8px;border:1px solid #000;">Name of the Father / Guardian</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{father_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">3</td><td style="padding:5px 8px;border:1px solid #000;">Name of the Mother</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{mother_name}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">4</td><td style="padding:5px 8px;border:1px solid #000;">Date of Birth (in figures and words)</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{dob}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">5</td><td style="padding:5px 8px;border:1px solid #000;">Nationality, Religion and Caste</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{nationality}} / {{religion}} / {{category}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">6</td><td style="padding:5px 8px;border:1px solid #000;">PEN Number</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{pen_no}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">7</td><td style="padding:5px 8px;border:1px solid #000;">Aadhar Card Number</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{aadhar_no}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">8</td><td style="padding:5px 8px;border:1px solid #000;">Medium of Instruction</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{medium}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">9</td><td style="padding:5px 8px;border:1px solid #000;">Class last studied &amp; Promoted to</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{class_name}} &#8212; Promoted to {{promoted_class}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">10</td><td style="padding:5px 8px;border:1px solid #000;">Date of Leaving</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{leaving_date}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">11</td><td style="padding:5px 8px;border:1px solid #000;">Reason for Leaving</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{reason}}</b></td></tr>
    <tr><td style="padding:5px 8px;border:1px solid #000;">12</td><td style="padding:5px 8px;border:1px solid #000;">Conduct and Character</td><td style="padding:5px 8px;border:1px solid #000;"><b>{{conduct}}</b></td></tr>
  </table>
  <p style="margin-top:8px;font-size:12px;text-align:center;font-style:italic;">Certified that the above particulars have been carefully verified and found correct.</p>
</div>`;

// 15. Formal Plain TC — paragraph-style, no decorations
const FORMAL_PLAIN_BODY = `<div style="padding:16px 0;font-family:'Times New Roman',serif;font-size:14px;line-height:2.5;text-align:justify;">
  <div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:16px;">
    <span>Sl.No: <u>{{serial_no}}</u></span>
    <span>Admn.No: <u>{{admission_no}}</u></span>
    <span>Date: <u>{{date}}</u></span>
  </div>
  <p>This is to certify that&nbsp;<u><b>{{student_name}}</b></u>, Son / Daughter of&nbsp;<u><b>{{father_name}}</b></u>&nbsp;and Mother&nbsp;<u><b>{{mother_name}}</b></u>, was a student of this institution.</p>
  <p>He / She was studying in Class&nbsp;<u><b>{{class_name}}</b></u>&nbsp;&#8212; Section&nbsp;<u><b>{{section_name}}</b></u>&nbsp;during the Academic Year&nbsp;<u><b>{{academic_year}}</b></u>.</p>
  <p>Date of Birth as per school records:&nbsp;<u><b>{{dob}}</b></u>. Religion:&nbsp;<b>{{religion}}</b>. Nationality:&nbsp;<b>{{nationality}}</b>.</p>
  <p>His / Her conduct during the period of study at this institution was&nbsp;<u><b>{{conduct}}</b></u>.</p>
  <p>Transfer Certificate No.&nbsp;<u><b>{{tc_no}}</b></u>&nbsp;is hereby issued on request.</p>
</div>`;

// 16. Pink Lavender Bonafide — soft gradient, feminine style
const PINK_BONAFIDE_BODY = `<div style="padding:20px 10px;font-family:Georgia,serif;font-size:14px;line-height:3;text-align:center;color:#4a154b;">
  <div style="font-size:20px;color:#c2185b;letter-spacing:4px;margin-bottom:8px;">&#10022; &#10022; &#10022;</div>
  <p><i>This is to certify that</i></p>
  <p style="font-size:18px;font-weight:bold;color:#c2185b;text-decoration:underline;letter-spacing:2px;">{{student_name}}</p>
  <p><i>Son / Daughter of</i> <b>{{father_name}}</b></p>
  <p><i>was a Bonafide Student of this Institution during</i></p>
  <p style="font-size:16px;font-weight:bold;color:#7b1fa2;">{{academic_year}}</p>
  <p><i>studying in</i> <b>Class {{class_name}}</b> <i>&#8212; Section</i> <b>{{section_name}}</b></p>
  <p><i>Date of Birth:</i> <b>{{dob}}</b></p>
  <div style="border-top:2px solid #ce93d8;border-bottom:2px solid #ce93d8;padding:8px 0;margin-top:12px;color:#7b1fa2;font-weight:bold;font-size:15px;">
    His / Her Character &amp; Conduct has been Excellent throughout the period.
  </div>
</div>`;

// 17. Dark Premium TC — dark background, gold accents
const DARK_PREMIUM_BODY = `<div style="padding:8px 0;font-family:'Times New Roman',serif;color:#f0e6c8;">
  <div style="display:flex;justify-content:space-between;font-size:12px;color:#d4af6a;margin-bottom:14px;border-bottom:1px solid #d4af6a;padding-bottom:6px;">
    <span>Serial No: <b>{{serial_no}}</b></span>
    <span>TC No: <b>{{tc_no}}</b></span>
    <span>Date: <b>{{date}}</b></span>
  </div>
  <table style="width:100%;border-collapse:collapse;font-size:13px;">
    <thead>
      <tr><th colspan="2" style="background:#d4af6a;color:#1a1a2e;padding:8px;text-align:center;font-size:13px;letter-spacing:1.5px;">STUDENT PARTICULARS</th></tr>
    </thead>
    <tbody>
      <tr style="background:#16213e;"><td style="padding:7px 10px;border:1px solid #d4af6a;width:55%;color:#c5b8a0;">Name of the Pupil</td><td style="padding:7px 10px;border:1px solid #d4af6a;color:#f0e6c8;"><b>{{student_name}}</b></td></tr>
      <tr style="background:#1a1a2e;"><td style="padding:7px 10px;border:1px solid #d4af6a;color:#c5b8a0;">Father's Name</td><td style="padding:7px 10px;border:1px solid #d4af6a;color:#f0e6c8;"><b>{{father_name}}</b></td></tr>
      <tr style="background:#16213e;"><td style="padding:7px 10px;border:1px solid #d4af6a;color:#c5b8a0;">Mother's Name</td><td style="padding:7px 10px;border:1px solid #d4af6a;color:#f0e6c8;"><b>{{mother_name}}</b></td></tr>
      <tr style="background:#1a1a2e;"><td style="padding:7px 10px;border:1px solid #d4af6a;color:#c5b8a0;">Date of Birth</td><td style="padding:7px 10px;border:1px solid #d4af6a;color:#f0e6c8;"><b>{{dob}}</b></td></tr>
      <tr style="background:#16213e;"><td style="padding:7px 10px;border:1px solid #d4af6a;color:#c5b8a0;">Admission No / Class</td><td style="padding:7px 10px;border:1px solid #d4af6a;color:#f0e6c8;"><b>{{admission_no}} / {{class_name}} &#8212; {{section_name}}</b></td></tr>
      <tr style="background:#1a1a2e;"><td style="padding:7px 10px;border:1px solid #d4af6a;color:#c5b8a0;">Academic Year</td><td style="padding:7px 10px;border:1px solid #d4af6a;color:#f0e6c8;"><b>{{academic_year}}</b></td></tr>
      <tr style="background:#16213e;"><td style="padding:7px 10px;border:1px solid #d4af6a;color:#c5b8a0;">Conduct</td><td style="padding:7px 10px;border:1px solid #d4af6a;color:#f0e6c8;"><b>{{conduct}}</b></td></tr>
    </tbody>
  </table>
</div>`;

// ── Per-type default config ──────────────────────────────────────────────

export const TYPE_PRESETS = {
  tc: {
    certTitle:    'TRANSFER CERTIFICATE',
    certTitleColor: '#1a237e',
    border:       BORDER_PRESETS[0],
    bodyContent:  TC_BODY,
    signatures:   [{ label: 'Class Teacher' }, { label: 'Head of the Institution' }],
  },
  bonafide: {
    certTitle:    'BONAFIDE CERTIFICATE',
    certTitleColor: '#1a237e',
    border:       BORDER_PRESETS[0],
    bodyContent:  BONAFIDE_BODY,
    signatures:   [{ label: 'Clerk' }, { label: 'Head of the Institution' }],
  },
  study: {
    certTitle:    'STUDY CERTIFICATE',
    certTitleColor: '#1a237e',
    border:       BORDER_PRESETS[0],
    bodyContent:  STUDY_BODY,
    signatures:   [{ label: 'Clerk' }, { label: 'Head of the Institution' }],
  },
  recordsheet: {
    certTitle:    'RECORD SHEET',
    certTitleColor: '#000000',
    border:       BORDER_PRESETS[1],
    bodyContent:  RECORD_BODY,
    signatures:   [{ label: 'Sign of In-charge' }, { label: 'Head of the School' }],
  },
  idcard: {
    certTitle:    'STUDENT ID CARD',
    certTitleColor: '#6a0dad',
    border:       BORDER_PRESETS[8],
    bodyContent:  '',
    signatures:   [],
  },
};

// ── 12 Template library cards ────────────────────────────────────────────

const BASE = {
  schoolName: '',
  recognitionText: '',
  address: '',
  phone: '',
  alignment: 'center',
};

export const TEMPLATE_LIBRARY = [
  // 1. Classic TC
  {
    id: 'tc_classic',
    name: 'Classic TC',
    badge: 'TC',
    color: '#1a237e',
    category: 'tc',
    description: 'Traditional navy blue TC with table layout',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#1a237e',
      border: BORDER_PRESETS[0], bgType: 'white',
      bodyContent: TC_BODY,
      signatures: [{ label: 'Class Teacher' }, { label: 'Head of the Institution' }],
    },
  },
  // 2. Study Certificate — classic school style (matches physical certificate format)
  {
    id: 'study_purple',
    name: 'Classic Study',
    badge: 'SC',
    color: '#1a237e',
    category: 'study',
    description: 'Classic navy blue study certificate — bonafide paragraph style',
    config: {
      ...BASE,
      certType: 'study', certTitle: 'STUDY CERTIFICATE',
      schoolNameSize: 26, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#1a237e',
      border: BORDER_PRESETS[0], bgType: 'white',
      bodyContent: STUDY_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Head of the Institution' }],
    },
  },
  // 3. Bonafide Classic
  {
    id: 'bonafide_classic',
    name: 'Bonafide Classic',
    badge: 'BF',
    color: '#1a237e',
    category: 'bonafide',
    description: 'Classic navy formal bonafide certificate',
    config: {
      ...BASE,
      certType: 'bonafide', certTitle: 'BONAFIDE CERTIFICATE',
      schoolNameSize: 26, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#1a237e',
      border: BORDER_PRESETS[0], bgType: 'white',
      bodyContent: BONAFIDE_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Head of the Institution' }],
    },
  },
  // 4. Record Sheet
  {
    id: 'record_sheet',
    name: 'Record Sheet',
    badge: 'RS',
    color: '#374151',
    category: 'recordsheet',
    description: 'Double border official record sheet (16 fields)',
    config: {
      ...BASE,
      certType: 'recordsheet', certTitle: 'RECORD SHEET',
      schoolNameSize: 22, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#000000',
      border: BORDER_PRESETS[1], bgType: 'white',
      bodyContent: RECORD_BODY,
      signatures: [{ label: 'Sign of In-charge' }, { label: 'Head of the School' }],
    },
  },
  // 5. Golden School Style
  {
    id: 'golden_school',
    name: 'School Style',
    badge: '★',
    color: '#B8860B',
    category: 'bonafide',
    description: 'Golden decorative borders — regal look',
    config: {
      ...BASE,
      certType: 'bonafide', certTitle: 'BONAFIDE CERTIFICATE',
      schoolNameSize: 24, schoolNameColor: '#B8860B',
      certTitleSize: 18, certTitleColor: '#8B4513',
      border: BORDER_PRESETS[4], bgType: 'white',
      bodyContent: BONAFIDE_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Principal' }],
    },
  },
  // 6. Elegant Blue
  {
    id: 'elegant_blue',
    name: 'Elegant Blue',
    badge: '◈',
    color: '#1565c0',
    category: 'bonafide',
    description: 'Blue gradient background with decorators',
    config: {
      ...BASE,
      certType: 'bonafide', certTitle: 'BONAFIDE CERTIFICATE',
      schoolNameSize: 24, schoolNameColor: '#1565c0',
      certTitleSize: 16, certTitleColor: '#1565c0',
      border: { id: 'elegant_blue', style: 'solid', thickness: 4, color: '#1565c0', radius: 8, inner: true, innerColor: '#90caf9', innerThickness: 1, innerInset: 10 },
      bgType: 'gradient',
      bgGradientStart: '#e3f2fd',
      bgGradientEnd: '#ffffff',
      bgGradientDir: 'to bottom',
      bodyContent: ELEGANT_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Principal' }],
    },
  },
  // 7. Royal Maroon TC
  {
    id: 'royal_maroon',
    name: 'Royal Maroon TC',
    badge: '♛',
    color: '#800000',
    category: 'tc',
    description: 'Maroon royal styled TC with striped table',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#800000',
      certTitleSize: 16, certTitleColor: '#800000',
      border: BORDER_PRESETS[5], bgType: 'white',
      bodyContent: MAROON_TC_BODY,
      signatures: [{ label: 'Class Teacher' }, { label: 'Head of the Institution' }],
    },
  },
  // 8. Green Minimal Study
  {
    id: 'green_minimal',
    name: 'Green Minimal',
    badge: '◉',
    color: '#16a34a',
    category: 'study',
    description: 'Clean green accents, left-aligned modern layout',
    config: {
      ...BASE,
      certType: 'study', certTitle: 'STUDY CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#15803d',
      certTitleSize: 16, certTitleColor: '#15803d',
      border: BORDER_PRESETS[6], bgType: 'white',
      bodyContent: GREEN_STUDY_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Principal' }],
    },
  },
  // 9. Government Official TC
  {
    id: 'govt_official',
    name: 'Govt. Official',
    badge: '⊛',
    color: '#374151',
    category: 'tc',
    description: 'Formal black & white government style TC',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#000000',
      border: { id: 'govt', style: 'solid', thickness: 2, color: '#000000', radius: 0, inner: true, innerColor: '#000000', innerThickness: 0.5, innerInset: 6 },
      bgType: 'white',
      bodyContent: GOVT_TC_BODY,
      signatures: [{ label: 'Principal' }, { label: 'DEO / HM Seal' }],
    },
  },
  // 10. Decorative Ornate Bonafide
  {
    id: 'ornate_bonafide',
    name: 'Decorative Ornate',
    badge: '❧',
    color: '#8B4513',
    category: 'bonafide',
    description: 'Brown decorative borders, classical ornate style',
    config: {
      ...BASE,
      certType: 'bonafide', certTitle: 'BONAFIDE CERTIFICATE',
      schoolNameSize: 24, schoolNameColor: '#8B4513',
      certTitleSize: 18, certTitleColor: '#8B4513',
      border: BORDER_PRESETS[2], bgType: 'white',
      bodyContent: ORNATE_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Headmaster' }],
    },
  },
  // 11. Academic Pro Record
  {
    id: 'academic_pro',
    name: 'Academic Pro',
    badge: 'AP',
    color: '#1a237e',
    category: 'recordsheet',
    description: 'Extended record sheet with blue header rows',
    config: {
      ...BASE,
      certType: 'recordsheet', certTitle: 'ACADEMIC RECORD SHEET',
      schoolNameSize: 22, schoolNameColor: '#1a237e',
      certTitleSize: 16, certTitleColor: '#1a237e',
      border: BORDER_PRESETS[0], bgType: 'white',
      bodyContent: ACADEMIC_RECORD_BODY,
      signatures: [{ label: 'Class Teacher' }, { label: 'Head of the School' }],
    },
  },
  // 12. Teal Two-Column TC
  {
    id: 'teal_two_col',
    name: 'Teal Landscape',
    badge: '⊞',
    color: '#0891b2',
    category: 'tc',
    description: 'Teal borders with two-column detail grid',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#0891b2',
      certTitleSize: 16, certTitleColor: '#0891b2',
      border: BORDER_PRESETS[7], bgType: 'white',
      bodyContent: TEAL_BODY,
      signatures: [{ label: 'Class Teacher' }, { label: 'Head of the Institution' }],
    },
  },
  // 13. Minimal Modern Study
  {
    id: 'minimal_modern',
    name: 'Minimal Modern',
    badge: '◻',
    color: '#7c3aed',
    category: 'study',
    description: 'No border, card-style data blocks, clean typography',
    config: {
      ...BASE,
      certType: 'study', certTitle: 'STUDY CERTIFICATE',
      schoolNameSize: 26, schoolNameColor: '#7c3aed',
      certTitleSize: 16, certTitleColor: '#7c3aed',
      border: BORDER_PRESETS[8], bgType: 'white',
      bodyContent: MINIMAL_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Principal' }],
    },
  },
  // 14. Saffron Tricolor TC
  {
    id: 'saffron_tricolor',
    name: 'Saffron Tricolor',
    badge: '🇮',
    color: '#FF9933',
    category: 'tc',
    description: 'India flag saffron/green accent TC with striped table',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#FF9933',
      certTitleSize: 16, certTitleColor: '#FF9933',
      border: {
        id: 'saffron', style: 'solid', thickness: 5, color: '#FF9933',
        radius: 2, inner: true, innerColor: '#138808', innerThickness: 1.5, innerInset: 10,
      },
      bgType: 'white',
      bodyContent: SAFFRON_TC_BODY,
      signatures: [{ label: 'Class Teacher' }, { label: 'Head of the Institution' }],
    },
  },
  // 15. TS Government Official TC
  {
    id: 'ts_govt_official',
    name: 'TS Govt. Official',
    badge: 'TS',
    color: '#374151',
    category: 'tc',
    description: 'Telangana government numbered TC with PEN/Aadhar fields',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#000000',
      border: {
        id: 'ts_govt', style: 'solid', thickness: 2, color: '#000000',
        radius: 0, inner: true, innerColor: '#000000', innerThickness: 0.5, innerInset: 6,
      },
      bgType: 'white',
      bodyContent: TS_GOVT_BODY,
      signatures: [{ label: 'Principal' }, { label: 'DEO / HM Seal' }],
    },
  },
  // 16. Formal Plain TC
  {
    id: 'formal_plain',
    name: 'Formal Plain',
    badge: 'FP',
    color: '#374151',
    category: 'tc',
    description: 'Paragraph-style TC, no table, clean official text',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#000000',
      border: BORDER_PRESETS[0], bgType: 'white',
      bodyContent: FORMAL_PLAIN_BODY,
      signatures: [{ label: 'Class Teacher' }, { label: 'Head of the Institution' }],
    },
  },
  // 17. Pink Lavender Bonafide
  {
    id: 'pink_lavender',
    name: 'Pink Lavender',
    badge: '✦',
    color: '#c2185b',
    category: 'bonafide',
    description: 'Soft pink/lavender gradient, elegant centered bonafide',
    config: {
      ...BASE,
      certType: 'bonafide', certTitle: 'BONAFIDE CERTIFICATE',
      schoolNameSize: 24, schoolNameColor: '#c2185b',
      certTitleSize: 18, certTitleColor: '#7b1fa2',
      border: {
        id: 'pink', style: 'solid', thickness: 4, color: '#c2185b',
        radius: 16, inner: true, innerColor: '#ce93d8', innerThickness: 1, innerInset: 10,
      },
      bgType: 'gradient',
      bgGradientStart: '#fce4ec',
      bgGradientEnd: '#f3e5f5',
      bgGradientDir: 'to bottom',
      bodyContent: PINK_BONAFIDE_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Principal' }],
    },
  },
  // 19. Student ID Card — Purple Wave (classic)
  {
    id: 'student_id_card',
    name: 'ID Card — Purple Wave',
    badge: 'ID',
    color: '#6a0dad',
    category: 'idcard',
    description: 'Classic purple wave ID card with circular photo',
    config: {
      ...BASE,
      certType: 'idcard', certTitle: 'STUDENT ID CARD',
      idCardStyle: 'wave',
      schoolNameSize: 16, schoolNameColor: '#ffffff',
      certTitleSize: 14, certTitleColor: '#6a0dad',
      border: BORDER_PRESETS[8], bgType: 'white',
      bodyContent: '',
      signatures: [],
    },
  },
  // 20. Student ID Card — Teal Split (modern)
  {
    id: 'student_id_card_sidebar',
    name: 'ID Card — Teal Split',
    badge: 'ID',
    color: '#00897b',
    category: 'idcard',
    description: 'Modern teal two-panel ID card — photo on left sidebar',
    config: {
      ...BASE,
      certType: 'idcard', certTitle: 'STUDENT ID CARD',
      idCardStyle: 'sidebar',
      schoolNameSize: 13, schoolNameColor: '#00897b',
      certTitleSize: 12, certTitleColor: '#00897b',
      border: BORDER_PRESETS[8], bgType: 'white',
      bodyContent: '',
      signatures: [],
    },
  },
  // 21. Student ID Card — Red Formal (academic)
  {
    id: 'student_id_card_formal',
    name: 'ID Card — Red Formal',
    badge: 'ID',
    color: '#b71c1c',
    category: 'idcard',
    description: 'Academic red formal ID card with rectangular photo on left',
    config: {
      ...BASE,
      certType: 'idcard', certTitle: 'STUDENT ID CARD',
      idCardStyle: 'formal',
      schoolNameSize: 13, schoolNameColor: '#b71c1c',
      certTitleSize: 12, certTitleColor: '#b71c1c',
      border: BORDER_PRESETS[8], bgType: 'white',
      bodyContent: '',
      signatures: [],
    },
  },
  // 22. Student ID Card — Dark Premium (elegant)
  {
    id: 'student_id_card_dark',
    name: 'ID Card — Dark Premium',
    badge: 'ID',
    color: '#d4af37',
    category: 'idcard',
    description: 'Dark navy premium ID card with gold accents',
    config: {
      ...BASE,
      certType: 'idcard', certTitle: 'STUDENT ID CARD',
      idCardStyle: 'dark',
      schoolNameSize: 13, schoolNameColor: '#d4af37',
      certTitleSize: 12, certTitleColor: '#d4af37',
      border: BORDER_PRESETS[8], bgType: 'white',
      bodyContent: '',
      signatures: [],
    },
  },
  // 18. Dark Premium TC
  {
    id: 'dark_premium',
    name: 'Dark Premium',
    badge: '◈',
    color: '#d4af6a',
    category: 'tc',
    description: 'Dark navy background with gold accents — premium look',
    config: {
      ...BASE,
      certType: 'tc', certTitle: 'TRANSFER CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#d4af6a',
      certTitleSize: 16, certTitleColor: '#d4af6a',
      border: {
        id: 'dark_gold', style: 'solid', thickness: 6, color: '#d4af6a',
        radius: 4, inner: true, innerColor: '#8B6914', innerThickness: 1.5, innerInset: 10,
      },
      bgType: 'color',
      bgColor: '#1a1a2e',
      bodyContent: DARK_PREMIUM_BODY,
      signatures: [{ label: 'Class Teacher' }, { label: 'Head of the Institution' }],
    },
  },
  // 23. Rizee-EDU Bonafide — pre-filled with Rizee-EDU branding (logo, name & address)
  {
    id: 'rizee_edu_bonafide',
    name: 'Rizee-EDU Bonafide',
    badge: 'BF',
    color: '#1a237e',
    category: 'bonafide',
    description: 'Bonafide certificate pre-filled with Rizee-EDU logo, name & address',
    config: {
      ...BASE,
      certType: 'bonafide', certTitle: 'BONAFIDE CERTIFICATE',
      schoolNameSize: 22, schoolNameColor: '#000000',
      certTitleSize: 16, certTitleColor: '#1a237e',
      border: BORDER_PRESETS[0], bgType: 'white',
      recognitionText: 'Recognised by the Govt. of T.G.',
      logoUrl: 'https://support.rizee.in/files/Rizee_123.jpeg',
      schoolName: 'Rizee-EDU Eucations',
      address: 'Udaya Royal Crest, Flat No.201, D.No : 2-40/129/A & 129/B/URC/201, Kothaguda, Kondapur, Hyderabad-500084.',
      bodyContent: BONAFIDE_BODY,
      signatures: [{ label: 'Clerk' }, { label: 'Head of the Institution' }],
    },
  },
  // 23b. Student ID Card — Green Wave (front & back)
  {
    id: 'student_id_card_green',
    name: 'ID Card — Green Wave',
    badge: 'ID',
    color: '#6e8b1f',
    category: 'idcard',
    description: 'White header with rectangular photo, green wave footer — includes a matching back side',
    config: {
      ...BASE,
      certType: 'idcard', certTitle: 'STUDENT ID CARD',
      idCardStyle: 'green',
      schoolNameSize: 14, schoolNameColor: '#1a1a1a',
      certTitleSize: 12, certTitleColor: '#6e8b1f',
      border: BORDER_PRESETS[8], bgType: 'white',
      bodyContent: '',
      signatures: [],
    },
  },
  // 24. Rizee-EDU ID Card — pre-filled with Rizee-EDU branding (logo, name & address)
  {
    id: 'rizee_edu_id_card',
    name: 'Rizee-EDU ID Card',
    badge: 'ID',
    color: '#6a0dad',
    category: 'idcard',
    description: 'Student ID card pre-filled with Rizee-EDU logo, name & address',
    config: {
      ...BASE,
      certType: 'idcard', certTitle: 'STUDENT ID CARD',
      idCardStyle: 'wave',
      schoolNameSize: 16, schoolNameColor: '#ffffff',
      certTitleSize: 14, certTitleColor: '#6a0dad',
      border: BORDER_PRESETS[8], bgType: 'white',
      logoUrl: 'https://support.rizee.in/files/Rizee_123.jpeg',
      schoolName: 'Rizee-EDU Eucations',
      address: 'Udaya Royal Crest, Flat No.201, D.No : 2-40/129/A & 129/B/URC/201, Kothaguda, Kondapur, Hyderabad-500084.',
      bodyContent: '',
      signatures: [],
    },
  },
];
